import { GetSessionData, UpdateSessionData } from './../BL/Sessions'


const GetGenderMode = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "Admin/IsWomensModeActive", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        const data = await response.json()
        
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const SetGenderMode = async (activeWomensMode) => {
    try {
        const dataToSend = {
            showFemaleMode: activeWomensMode
        }
        
        const response = await fetch(process.env.REACT_APP_API_URL + "Admin/SetGenderMode", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }

        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

/**
 * Función que valida que el usuario tenga una zona (del estadio) asignada y sea válida
 */
const ValidateCurrentZone = async () => {
    try {
        const response = await GetSessionData()

        if (response.success) {
            const zone = response?.data?.navigation?.zone?.id

            if (zone) {
                if (!Number.isInteger(zone) || zone < 1 || zone > 11) {
                    return { success: false, message: null }
                } else {
                    return {
                        success: true,
                        data: {
                            id: zone,
                            name: response?.data?.navigation?.zone?.name || null,
                            text: response?.data?.navigation?.zone?.text || null
                        }
                    }
                }
            } else {
                return { success: false, message: null }
            }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar cargar la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

/**
 * Función que obtiene la información de la zona (del estadio) que tiene el usuario
 * @returns 
 */
const GetUserZone = async () => {
    try {
        const response = await GetSessionData()

        if (response.success) {
            const zone = response?.data?.navigation?.zone

            if (zone) {
                return { success: true, data: zone }
            } else {
                return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
            }
        } else {
            return { success: false, message: response.message }
        }  
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

/**
 * Función que guarda la zona (del estadio) que eligió el usuario o que le fue asignada
 * @param {object} zoneData
 * @returns 
 */
const SaveUserZone = async (zoneData) => {
    try {
        let responseSaveData = null
        const response = await GetSessionData()
    
        if (response.success) {
            response.data.navigation = {
                ...response.data.navigation,
                zone: {
                    id: zoneData.id,
                    name: zoneData.name,
                    text: zoneData.text
                }
            }

            responseSaveData = await UpdateSessionData(response.data)
        } else {
            const userData = {
                navigation: {
                    zone: {
                        id: zoneData.id,
                        name: zoneData.name,
                        text: zoneData.text
                    }
                }
            }

            responseSaveData = await UpdateSessionData(userData)
        }
        
        if (responseSaveData.success) {
            return { success: true, data: zoneData }            
        } else {
            return { success: false, message: 'Lo sentimos. Hubo un error al intentar guardar tu zona. Inténtalo nuevamente o inténtalo más tarde.' }
        }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar guardar tu zona. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const SubmitResponse = async (questionId, zone) => {
    try {
        const dataToSend = {
            questionId: questionId,
            zona: zone
        }
        
        const response = await fetch(process.env.REACT_APP_API_URL + "fan/submitCorrectResponse", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const SendQuestionToUsers = async (question) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "Admin/SendQuestion", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(question)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            if (response.status === 400) {
                const errorData = await response.json()
                
                if (errorData.message.toLowerCase() === 'No hay conexiones activas por zona. No se puede lanzar la pregunta.'.toLowerCase()) {
                    return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                } else {
                    return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                }
                // if (errorData) {
                //
                // } else {
                //     return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                // }
            } else {
                return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
            }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const GetAllResults = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "questions/getAllQuestionsResults", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        const data = await response.json()
        
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const GetResultsByQuestion = async (idQuestion) => {
    try {
        const dataToSend = {
            questionId: idQuestion
        }

        const response = await fetch(process.env.REACT_APP_API_URL + "results/getResultsByQuestion", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        const data = await response.json()

        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const ResetAllResults = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "admin/ResetAllResults", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const SendResultsToScreen = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "admin/SendAllResultsToScreen", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const GetColors = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "colors/getColorsConfig", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }

        const data = await response.json()
        
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const SetColor = async (idTheme) => {
    try {
        const dataToSend = {
            id: idTheme
        }
        
        const response = await fetch(process.env.REACT_APP_API_URL + "admin/SendColorByZone", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible establecer el tema que deseas. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar establecer el tema que deseas. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const ResetCurrentDynamic = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "admin/resetCurrentDynamic", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible establecer el tema que deseas. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar establecer el tema que deseas. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

//---------- LOTTERY ADMIN ----------//

const StartLottery = async (boardSize, view) => {
    try {
        const dataToSend = {
            "BoardSize": boardSize,
            "IdView": view
        }

        const response = await fetch(process.env.REACT_APP_API_URL + "Admin/StartLottery", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            if (response.status === 400) {
                const errorData = await response.json()
                
                // if (errorData.message.toLowerCase() === 'No hay conexiones activas por zona. No se puede lanzar la pregunta.'.toLowerCase()) {
                    return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                // } else {
                //    return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                // }
            } else {
                return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
            }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const SendNextCard = async (card, view) => {
    try {
        const dataToSend = {
            "IdCard": card,
            "IdView": view
        }

        const response = await fetch(process.env.REACT_APP_API_URL + "Admin/SendNextCardLottery", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            if (response.status === 400) {
                const errorData = await response.json()
                
                // if (errorData.message.toLowerCase() === 'No hay conexiones activas por zona. No se puede lanzar la pregunta.'.toLowerCase()) {
                    return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                // } else {
                //    return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                // }
            } else {
                return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
            }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const GetAllLotteryResults = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "Lottery/GetLotteryTotalPointsByZone", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            if (response.status === 400) {
                const errorData = await response.json()
                
                // if (errorData.message.toLowerCase() === 'No hay resultados registrados por zona.'.toLowerCase()) {
                    return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                // } else {
                //    return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                // }
            } else {
                return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
            }
        }
        
        const data = await response.json()
        
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const GetAllLotteryResultsByCard = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "Lottery/GetLotteryResultsByCard", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            if (response.status === 400) {
                const errorData = await response.json()
                
                // if (errorData.message.toLowerCase() === 'No hay resultados registrados por carta..'.toLowerCase()) {
                    return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                // } else {
                //    return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                // }
            } else {
                return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
            }
        }
        
        const data = await response.json()
        
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

//---------- LOTTERY ADMIN ----------//

//---------- BALLONS ADMIN ----------//

const StartBallonsGame = async (targetTapsPerBalloon, durationSeconds, countdownSeconds, threshold, timeoutMs) => {
  try {
    const dataToSend = {
        targetTapsPerBalloon: targetTapsPerBalloon,
        durationSeconds: durationSeconds,
        countdownSeconds: countdownSeconds,
        sendBatchThreshold:   threshold,
        sendBatchTimeoutMs:   timeoutMs
    }
    
    const response = await fetch(process.env.REACT_APP_API_URL + "admin/balloons/start", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend)
    })
    
    if (!response.ok) {
        // Manejar errores HTTP
        if (response.status === 400) {
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        } else {
            return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
    }
    
    const data = await response.json()
    
    // Retornar la respuesta exitosa
    return { success: true, data: data }
  } catch (error) {
    console.log('DL StartBallonsGame: ' + error)
  }
}

const RestartBallonsGame = async () => {
  try {
    const response = await fetch(process.env.REACT_APP_API_URL + "admin/balloons/reset", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        }
    })
    
    if (!response.ok) {
        // Manejar errores HTTP
        if (response.status === 400) {
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible reiniciar la partida de globos. Inténtalo nuevamente o inténtalo más tarde.' }
        } else {
            return { success: false, message: 'No ha sido posible reiniciar la partida de globos. Inténtalo nuevamente o inténtalo más tarde.' }
        }
    }
    
    const data = await response.json()
    
    // Retornar la respuesta exitosa
    return { success: true, data: data }
  } catch (error) {
    console.log('DL RestartBallonsGame: ' + error)
  }
}

const GetBalloonStats = async () => {
  try {
    const response = await fetch(process.env.REACT_APP_API_URL + "admin/balloons/stats", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    })
    
    if (!response.ok) {
        // Manejar errores HTTP
        if (response.status === 400) {
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        } else {
            return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
    }
    
    const data = await response.json()
    
    // Retornar la respuesta exitosa
    return { success: true, data: data }
  } catch (error) {
    console.log('DL GetBalloonStats: ' + error)
  }
}

const GetBalloonState = async () => {
  try {
    const response = await fetch(process.env.REACT_APP_API_URL + "admin/balloons/state", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    })
    
    if (!response.ok) {
        // Manejar errores HTTP
        if (response.status === 400) {
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        } else {
            return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
    }
    
    const data = await response.json()
    
    // Retornar la respuesta exitosa
    return { success: true, data: data }
  } catch (error) {
    console.log('DL GetBalloonState: ' + error)
  }
}

//---------- BALLONS ADMIN ----------//

//---------- RIDDLE ADMIN ----------//

const GetAllRiddleResults = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "riddle/getResults", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        const data = await response.json()
        
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const SendRiddleResultsToScreen = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "admin/riddle/sendAllResultsToScreen", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const SendRiddleQuestionToUsers = async (question) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "admin/riddle/sendQuestion", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(question)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            if (response.status === 400) {
                const errorData = await response.json()
                
                if (errorData.message.toLowerCase() === 'No hay conexiones activas por zona. No se puede lanzar la pregunta.'.toLowerCase()) {
                    return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                } else {
                    return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                }
                // if (errorData) {
                //
                // } else {
                //     return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                // }
            } else {
                return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
            }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const ShowItemOnScreen = async (question) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "admin/riddle/displayRiddleItemOnScreen", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(question)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
            // if (response.status === 400) {
            //
            // } else {
            //     return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
            // }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

//---------- RIDDLE ADMIN ----------//



//---------- LOTTERY FAN ----------//

const ValidateResponse = async (idCard, zone) => {
    try {
        const dataToSend = {
            "Zona": zone,
            "Id": idCard
        }
        
        const response = await fetch(process.env.REACT_APP_API_URL + "Fan/SubmitCorrectResponseLottery", { // Checar qué endPoint se debe llamar
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            if (response.status === 400) {
                const errorData = await response.json()
                
                // if (errorData.message.toLowerCase() === ''.toLowerCase()) {
                    return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                // } else {
                //    return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                // }
            } else {
                return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
            }
        }
        
        const data = await response.json()
        
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

//---------- LOTTERY FAN ----------//

//---------- LOTTERY FAN ----------//

const SendBalloonsTap = async (matchId, zone, amount) => {
  try {
    const dataToSend = {
        matchId,
        zone,
        amount
    }
    
    const response = await fetch(process.env.REACT_APP_API_URL + "Balloons/tap", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend)
    })
    
    if (!response.ok) {
        // Manejar errores HTTP
        if (response.status === 400) {
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        } else {
            return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
    }
    
    //const data = await response.json()
    
    // Retornar la respuesta exitosa
    return { success: true, data: null }
  } catch (error) {
    console.log(error)
  }
}

//---------- LOTTERY FAN ----------//

//---------- RIDDLE FAN ----------//

/**
 * Registra la votación del aficionado para la adivinanza activa en el estadio.
 * 
 * @async
 * @function SubmitRiddleResponse
 * @param {number|string} questionId - Identificador único de la pregunta/adivinanza.
 * @param {string} zone - Nombre canónico de la zona asignada al aficionado.
 * @param {number|string|null} [optionId=null] - Identificador de la opción seleccionada.
 * @param {string|null} [userUid=null] - Identificador único del dispositivo/aficionado para prevención de doble voto.
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const SubmitRiddleResponse = async (questionId, zone, optionId = null, userUid = null) => {
    try {
        const dataToSend = {
            id: Number(questionId),
            zone: zone,
            optionId: optionId !== null && optionId !== undefined ? Number(optionId) : undefined,
            userUid: userUid || undefined
        }
        
        const response = await fetch(process.env.REACT_APP_API_URL + "fan/submitRiddleCorrectResponse", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}))
            return { success: false, message: errorData.message || 'No ha sido posible registrar la respuesta. Intenta de nuevo.' }
        }
        
        const resData = await response.json().catch(() => null)
        return { success: true, data: resData }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar enviar tu respuesta.' }
    }
}

//---------- RIDDLE FAN ----------//



//---------- QuizzWithImageAndOptions ADMIN ----------//

const GetAllQuizzWithImageAndOptionsResults = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "QuizzWithImageAndOptions/getResults", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        const data = await response.json()
        
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const SendQuizzWithImageAndOptionsResultsToScreen = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "admin/QuizzWithImageAndOptions/sendAllResultsToScreen", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const SendQuizzWithImageAndOptionsQuestionToUsers = async (question) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "admin/QuizzWithImageAndOptions/sendQuestion", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(question)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            if (response.status === 400) {
                const errorData = await response.json()
                
                if (errorData.message.toLowerCase() === 'No hay conexiones activas por zona. No se puede lanzar la pregunta.'.toLowerCase()) {
                    return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                } else {
                    return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                }
                // if (errorData) {
                //
                // } else {
                //     return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
                // }
            } else {
                return { success: false, message: 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
            }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

//---------- RIDDLE ADMIN ----------//

//---------- QuizzWithImageAndOptions FAN ----------//

const SubmitQuizzWithImageAndOptionsResponse = async (questionId, zone) => {
    try {
        const dataToSend = {
            id: questionId,
            zone: zone
        }
        
        const response = await fetch(process.env.REACT_APP_API_URL + "fan/submitQuizzWithImageAndOptionsCorrectResponse", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        // Retornar la respuesta exitosa
        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

//---------- QuizzWithImageAndOptions FAN ----------//





const GetAutozoneState = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "zonesassignment/stats", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        const data = await response.json()
        
        // Retornar la respuesta exitosa
        return {
            success: true,
            data: {
                isAutozoneActive: !!data.isAutoAssignmentActive,
                stats: data.stats // si quisieras usar después
            }
        }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const SetAutozoneState = async(enabled) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + `zonesassignment/toggleAutozone?enabled=${enabled}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            return { success: false, message: errorData.message || 'No ha sido posible obtener la información de la página. Actualiza la página o intenta actualizarla más tarde.' }
        }
        
        const data = await response.json()
        
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

export { GetGenderMode, SetGenderMode, ValidateCurrentZone, GetUserZone, SaveUserZone, SubmitResponse, SendQuestionToUsers, GetAllResults, GetResultsByQuestion, ResetAllResults, SendResultsToScreen, GetColors, SetColor, ResetCurrentDynamic, StartLottery, SendNextCard, GetAllLotteryResults, GetAllLotteryResultsByCard, StartBallonsGame, RestartBallonsGame, GetBalloonStats, GetBalloonState, GetAllRiddleResults, SendRiddleResultsToScreen, SendRiddleQuestionToUsers, ShowItemOnScreen, ValidateResponse, SendBalloonsTap, SubmitRiddleResponse, GetAutozoneState, SetAutozoneState, GetAllQuizzWithImageAndOptionsResults, SendQuizzWithImageAndOptionsResultsToScreen, SendQuizzWithImageAndOptionsQuestionToUsers, SubmitQuizzWithImageAndOptionsResponse };